import styled from 'styled-components'

export const LayoutContainer = styled.main`
    margin: 0 10%;
`
